import React, { useState, useContext } from "react"
import { LoaderContext } from "components/Providers"
import styled from "styled-components"
import media from "assets/styles/media"
import colors from "assets/styles/colors"
import text from "assets/styles/text"

import GridView from "components/companies/GridView"
import BGGrid from "components/uIElements/BGGrid"
import { CompanyNode } from "types/companies"
import { LongPixelButton } from "components/buttons/LongPixelButton"

type Props = {
  companies: CompanyNode[]
}

const Companies: React.FC<Props> = ({ companies }) => {
  const [wrapper, setWrapper] = useState<HTMLElement | null>(null)

  const setLoad = useContext(LoaderContext).setLoad

  const handleClick = () => {
    setLoad("/companies")
  }

  const lineConfig = {
    sectionHeight: "100%",
    sectionRef: wrapper,
    animationClass: "companies",
    darkSection: true,
  }

  return (
    <Wrapper ref={ref => setWrapper(ref)} id={"Companies"} data-scroll-section>
      <BGGrid lineConfig={lineConfig} />
      <GridView fullScreen={false} companies={companies} />
      <BG />
      <Content>
        <Title1>View our</Title1>
        <Title2>Companies</Title2>
        <LongPixelButton
          color={colors.blue400}
          title={""}
          activeColor={colors.blue500}
          textColor={colors.white}
          pixelWidth={40}
          pixelHeight={10}
          onClick={handleClick}
          pixelsToChange={[
            { from: [1, 37], to: [-2, 38] },
            { from: [0, 38], to: [-2, 40] },
            { from: [1, 39], to: [-1, 39] },
            { from: [9, 0], to: [11, -2] },
            { from: [8, 1], to: [10, -1] },
            { from: [9, 2], to: [11, 1] },
            //pixels that dont move top right
            { from: [0, 34 + 5], to: [0, 34 + 5] },
            { from: [1, 33 + 5], to: [1, 33 + 5] },
            { from: [1, 32 + 5], to: [1, 32 + 5] },
            //pixels that dont move bottom left
            { from: [8, 0], to: [8, 0] },
            { from: [9, 1], to: [9, 1] },
            { from: [8, 2], to: [8, 2] },
          ]}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p>OUR PORTFOLIO</p>
            <svg
              className="pixel-child"
              viewBox="0 0 15 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.5 8.49998L14.5 6.49998L12.5 6.49998L12.5 8.49998L14.5 8.49998ZM12.5 6.49998L12.5 4.49997L10.5 4.49997L10.5 2.5L8.5 2.5L8.5 0.5L6.5 0.5L6.5 2.5L8.5 2.5L8.5 4.5L10.5 4.5L10.5 6.49998L12.5 6.49998ZM12.5 8.5L12.5 10.5L10.5 10.5L10.5 8.5L12.5 8.5ZM4.5 8.5L6.5 8.5L8.5 8.5L10.5 8.5L10.5 6.5L8.5 6.5L6.5 6.5L4.5 6.5L2.5 6.5L0.5 6.5L0.5 8.5L2.5 8.5L4.5 8.5ZM8.5 12.5L8.5 10.5L10.5 10.5L10.5 12.5L8.5 12.5ZM8.5 12.5L8.5 14.5L6.5 14.5L6.5 12.5L8.5 12.5Z"
                fill={colors.white}
              />
            </svg>
          </div>
        </LongPixelButton>
      </Content>
    </Wrapper>
  )
}

export default Companies

const Wrapper = styled.section`
  width: 100%;
  height: 83.333vw;
  position: relative;
  overflow: hidden;

  ${media.tablet} {
    height: 100vh;
  }
  ${media.mobile} {
    height: 100vh;
  }
`

const BG = styled.div`
  position: absolute;
  z-index: 2;
  display: flex;
  background-color: ${colors.black800};
  opacity: 0.8;
  flex-direction: column;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 24.306vw;
  ${media.tablet} {
    padding-top: 33.7vh;
  }
  ${media.mobile} {
    padding-top: 33.7vh;
  }
`

const Content = styled.div`
  position: absolute;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 24.306vw;
  ${media.tablet} {
    padding-top: 33.7vh;
  }
  ${media.mobile} {
    padding-top: 33.7vh;
  }
`

const Title1 = styled.h2`
  ${text.desktop.h2}
  color: ${colors.white};
  ${media.tablet} {
    ${text.tablet.h3};
  }
  ${media.mobile} {
    ${text.mobile.h4};
    font-size: 24vw;
  }
`

const Title2 = styled.h2`
  ${text.desktop.d1Point5}
  color: ${colors.white};

  margin-bottom: 5.208vw;
  ${media.tablet} {
    ${text.tablet.d2Point5};
  }
  ${media.mobile} {
    font-size: 16vw;
    margin-bottom: 13.33vw;
    ${text.mobile.d3Point5};
  }
`
